// extracted by mini-css-extract-plugin
export default {"footerContainer":"styles_footerContainer__DuvX9","footer":"styles_footer__T403d","content":"styles_content__jpcqt"};